package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.until
import ir.site.zero1plus.components.style.MyParagraphStyle
import ir.site.zero1plus.components.widgets.PrimaryButton
import ir.site.zero1plus.model.NavBarMenu
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


val HeroImageSize by StyleVariable<CSSLengthNumericValue>(450.px)

val HeroImageStyle = CssStyle {
    base {
        Modifier
            .size(HeroImageSize.value())
            .transform { scaleX(-1) }
    }
    until(Breakpoint.LG) {
        Modifier.setVariable(HeroImageSize, 350.px)
    }
    until(Breakpoint.MD) {
        Modifier.setVariable(HeroImageSize, 250.px)
    }

}

@Composable
fun HeroSection() {
    Box(
        modifier = Modifier.id(NavBarMenu.Home.id)
            .fillMaxWidth()
            .height(95.vh),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(90.percent)
                .fillMaxHeight(),
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            HeroDesc()
            HeroImage()
        }
    }
}

@Composable
fun HeroImage() {

    Box(
        modifier = Modifier.displayIfAtLeast(Breakpoint.SM),
        contentAlignment = Alignment.Center
    ) {
        Image(
            modifier = HeroImageStyle.toModifier()
//                .displayIfAtLeast(Breakpoint.SM)
            ,
            src = "fgavatardark.svg",
            description = "hero image"
        )
    }
}

@Composable
fun HeroDesc() {
    Column(
        modifier = Modifier.width(250.px)
    ) {
        H2(attrs = Modifier.margin(0.px).fontSize(clamp(24.px, 5.vw, 28.px)).lineHeight(2.0).toAttrs()) {
            SpanText(
                modifier = Modifier.display(DisplayStyle.Block), text = "طراحی ،"
            )
            SpanText(
                modifier = Modifier.display(DisplayStyle.Block), text = "برنامه نویسی ،"
            )
            SpanText(
                modifier = Modifier.display(DisplayStyle.Block), text = "تکنولوژیی"
            )
        }
        P(attrs = MyParagraphStyle.toModifier().margin(topBottom = 16.px).lineHeight(2.0).toAttrs()) {
            Text("با استفاده از تکنولوژی های جدید طراحی و برنامه نویسی ، وبسایت و اپ موبایل میسازم")
        }
        PrimaryButton(
            onClick = {
                val element = document.getElementById(NavBarMenu.ContactDetails.id)!!
                val navHeaderHeight = 64
                val top = element.getBoundingClientRect().top
                val offset = top + (window.pageYOffset - navHeaderHeight)
                window.scrollTo(y = offset, x = 0.0)
//                document.getElementById(NavBarMenu.Services.id)?.scrollIntoView()
            }
        ) {
            Text("ارتباط با من")
        }
    }
}












